import React, {useMemo, useState, useEffect, FC} from 'react'

import './DashboardAdminWA.css'

import axios from 'axios'
import dayjs from 'dayjs'
import duration from "dayjs/plugin/duration";
import {Row, Col, Card, Button} from 'react-bootstrap'
import {Table, Spin, DatePicker} from 'antd'

const {RangePicker} = DatePicker
dayjs.extend(duration);

interface AvgResponseSummary {
  AvgResponseSeconds: number;
  AvgResponseMinutes: number;
  TotalChatsToday?: number;
  TotalClientMessages?: number;
  TotalResponded?: number;
}


const apiChat = process.env.REACT_APP_API_CHAT_URL || process.env.REACT_APP_API_URL || ''
const DashboardAdminWA: FC = () => {
   const base = process.env.REACT_APP_WA_BACKEND_API_URL || ''
    
  const userRole = localStorage.getItem('userRole') as string;
  const today = new Date()
  const [dateFrom, setDateFrom] = useState<any>(new Date().toISOString().split('T')[0])
  const [dateTo, setDateTo] = useState<any>(new Date().toISOString().split('T')[0])
  const userName = localStorage.getItem('username') as string
  const formatDate = (date: any) => {
    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const year = date.getFullYear()
    return `${day}-${month}-${year}`
  }

  // Broadcast table state (home)
  const [bLoading, setBLoading] = useState<boolean>(false)
  const [bData, setBData] = useState<any[]>([])
  const [bPage, setBPage] = useState<number>(1)
  const [bPageSize, setBPageSize] = useState<number>(10)
  const [bTotal, setBTotal] = useState<number>(0)
  const [favgData, setFavgData] = useState<AvgResponseSummary | null>(null);
  const [davgData, setDavgData] = useState<AvgResponseSummary | null>(null);


  const avgFirstResponseTime = useMemo(() => {
    if (!favgData) return 0;
    return (favgData.AvgResponseSeconds ?? 0) * 1000; // jadi ms
  }, [favgData]);

  const avgResponseTime = useMemo(() => {
    if (!davgData) return 0;
    return (davgData.AvgResponseSeconds ?? 0) * 1000;
  }, [davgData]);



  const fetchAVGFirst = async (from?: string | null, to?: string | null) => {
    try {
      let url = `${base.replace(/\/$/, '')}/conversation/reportavgfirst`;
      const params: string[] = [];
      if (from) params.push(`from=${encodeURIComponent(from)}`);
      if (to) params.push(`to=${encodeURIComponent(to)}`);
      if (params.length) url += `?${params.join('&')}`;

      const resp = await axios.get(url);
      const data = resp?.data?.data || resp?.data || [];
      setFavgData(data);
    } catch (err) {
      console.error('Failed to fetch first average', err);
    }
  };

  const fetchAVGDays = async (from?: string | null, to?: string | null) => {
    try {
      let url = `${base.replace(/\/$/, '')}/conversation/reportday`;
      const params: string[] = [];
      if (from) params.push(`from=${encodeURIComponent(from)}`);
      if (to) params.push(`to=${encodeURIComponent(to)}`);
      if (params.length) url += `?${params.join('&')}`;
      
      const resp = await axios.get(url);
      const data = resp?.data?.data || resp?.data || [];
      setDavgData(data);
    } catch (err) {
      console.error('Failed to fetch daily average', err);
    }
  };

  const fetchBroadcastsHome = async (
    page = 1,
    take = 10,
    from?: string | null,
    to?: string | null
  ) => {
    if (!base) return;
    setBLoading(true);
    try {
      const params: string[] = [];
      params.push(`page=${page}`);
      params.push(`take=${take}`);
      if (from) params.push(`from=${encodeURIComponent(from)}`);
      if (to) params.push(`to=${encodeURIComponent(to)}`);
      const url = `${base.replace(/\/$/, '')}/broadcast?${params.join('&')}`;
      const resp = await axios.get(url);
      const data = resp?.data?.data || resp?.data || [];
      const total = typeof resp?.data?.total === 'number' ? resp.data.total : Array.isArray(data) ? data.length : 0;
      setBData(Array.isArray(data) ? data : []);
      setBTotal(total);
    } catch (err) {
      console.error('Failed to fetch broadcasts for home', err);
      setBData([]);
      setBTotal(0);
    } finally {
      setBLoading(false);
    }
  };


  const fetchNewChatAssign = async () => {
    let query = `status=Assigned&user=${userRole}&userName=${userName}`
    try {
      const res = await axios.get(`${apiChat}/all-chat-assign?${query}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      })

      if (res.data) {
        // keep prior behavior for counts if needed
      }
    } catch (err) {
      console.error('Failed to fetch new chats', err)
    }
  }
  const fetchNewChatUnAssign = async () => {
    let query = `status=Unassigned&user=${userRole}`
    try {
      const res = await axios.get(`${apiChat}/all-chat-assign?${query}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      })

      if (res.data) {
        // response received for unassigned chats; not displayed on home
      }
    } catch (err) {
      console.error('Failed to fetch new chats', err)
    }
  }
  const fetchNewChatResolve = async () => {
    let query = `status=Resolved&user=${userRole}&userName=${userName}`
    try {
      const res = await axios.get(`${apiChat}/all-chat-assign?${query}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      })

      if (res.data) {
        // response received for resolved chats; not displayed on home
      }
    } catch (err) {
      console.error('Failed to fetch new chats', err)
    }
  }
  const fetchClosedChat = async () => {
    let query = `userName=${userName}`
    try {
      const res = await axios.get(`${apiChat}/all-closed-chat?${query}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      })

      if (res.data) {
        // setTotalResolved(res.data.chats.length)
        const totalAvgResponseTime = res.data.closedChats.reduce(
          (acc: number, chat: { avgResponseTime: number }) => acc + chat.avgResponseTime,
          0
        );
        //(totalAvgResponseTime)
        // console.log("Total Average Response Time:", totalAvgResponseTime);
        
        //  console.log(res.data.chats);
      }
    } catch (err) {
      console.error('Failed to fetch new chats', err)
    }
  }
  const fetchFirstChat = async () => {
    let query = `userName=${userName}`
    try {
      const res = await axios.get(`${apiChat}/first-response-handling?${query}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      })

      if (res.data) {
        console.log(res.data);
        const totalTime = Object.values(res.data.firstResponseTimes).reduce(
          (acc: number, chat: any) => acc + chat.responseTime,
          0
        );
        // setTotalResolved(res.data.chats.length)
        // const totalAvgResponseTime = res.data.closedChats.reduce(
        //   (acc: number, chat: { avgResponseTime: number }) => acc + chat.avgResponseTime,
        //   0
        // );
        //setAvgFirstResponseTime(totalTime)
        // console.log("Total Average Response Time:", totalAvgResponseTime);
        
        //  console.log(res.data.chats);
      }
    } catch (err) {
      console.error('Failed to fetch new chats', err)
    }
  }
useEffect(() => {
  // fetchNewChatAssign()
  // fetchNewChatUnAssign()
  // fetchNewChatResolve()
  // fetchClosedChat()
  // fetchFirstChat()

  // initial load for home tables
   fetchBroadcastsHome(bPage, bPageSize, dateFrom, dateTo)
  fetchAVGDays(dateFrom, dateTo)   // fetch average harian
  fetchAVGFirst(dateFrom, dateTo)  // fetch average first response
}, [])

useEffect(() => {
   fetchBroadcastsHome(bPage, bPageSize, dateFrom, dateTo)
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [bPage, bPageSize])

 function formatTimeFromMs(totalMs: number | null | undefined) {
    if (!totalMs || totalMs <= 0) return "00h 00m 00s 000ms";

    const ms = totalMs % 1000;
    const totalSeconds = Math.floor(totalMs / 1000);
    const seconds = totalSeconds % 60;
    const totalMinutes = Math.floor(totalSeconds / 60);
    const minutes = totalMinutes % 60;
    const hours = Math.floor(totalMinutes / 60);

    const pad = (n: number, len = 2) => String(n).padStart(len, "0");

    return `${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s ${pad(ms, 3)}ms`;
  }

  return (
    <section id='dashboard-tukang'>
      <Row>
        <Col xxl={6} xl={6} lg={12} className='mb-5'>
          <Row>
            <Col xxl={3} xl={3} lg={3} className='d-flex align-items-center'>
              <h3 className='title-header fs-5 fw-normal'>Rentang Waktu</h3>
            </Col>

            <Col xxl={5} xl={5} lg={5}>
              <RangePicker
                format={'DD-MM-YYYY'}
                className='date-range w-100 mb-3'
                defaultValue={[
                  dayjs(`${formatDate(today)}`, 'DD-MM-YYYY'),
                  dayjs(`${formatDate(today)}`, 'DD-MM-YYYY'),
                ]}
                onChange={(values) => {
                  if (values && values.length === 2) {
                    const dateFromFormatted = values[0]?.format('YYYY-MM-DD')
                    const dateToFormatted = values[1]?.format('YYYY-MM-DD')

                    setDateFrom(dateFromFormatted)
                    setDateTo(dateToFormatted)
                  } else {
                    setDateFrom(new Date().toISOString().split('T')[0])
                    setDateTo(new Date().toISOString().split('T')[0])
                  }
                }}
              />
            </Col>

            <Col xxl={4} xl={4} lg={4}>
              <Button
                className='btn-dark-primary button-submit m-0'
                // disabled={loadingButton}
                onClick={() => {
                  // panggil fetch untuk broadcast dan average berdasarkan tanggal range
                  fetchBroadcastsHome(bPage, bPageSize, dateFrom, dateTo)
                  fetchAVGDays(dateFrom, dateTo)   // fetch average harian
                  fetchAVGFirst(dateFrom, dateTo)  // fetch average first response
                  setBPage(1)      // reset page ke 1
                }}
              >
                Sumbit
              </Button>
            </Col>
          </Row>
        </Col>

        <Col xxl={6} xl={6} lg={12} className='mb-5'></Col>
      </Row>

     <Row className="g-4">
      <Col xl={6}>
        <Card className="text-center p-4 shadow-sm">
          <h2 className="fw-bold">
            {formatTimeFromMs(avgFirstResponseTime)}
          </h2>
          <p className="text-muted mb-0">
            Average First Response Time
          </p>
        </Card>
      </Col>

      <Col xl={6}>
        <Card className="text-center p-4 shadow-sm">
          <h2 className="fw-bold">
            {formatTimeFromMs(avgResponseTime)}
          </h2>
          <p className="text-muted mb-0">
            Average Response Time
          </p>
        </Card>
      </Col>
    </Row>


      <Row>
        <Col lg={12} md={12} className='mb-3'>
          <Card className='card'>
            <Card.Body>
              <h5 className='mb-3 d-flex justify-content-between align-items-center'>
                <span>Broadcast History</span>
              </h5>

              {bLoading ? (
                <div className='text-center'><Spin /></div>
              ) : (
                <Table
                  dataSource={bData.map((r:any, idx:number) => ({ key: r.detail_id || idx, ...r }))}
                  pagination={{
                    current: bPage,
                    pageSize: bPageSize,
                    total: bTotal,
                    onChange: (pg, ps) => { setBPage(pg); setBPageSize(ps); },
                    showSizeChanger: true,
                  }}
                  columns={[
                    { title: 'No', render: (_: any, __: any, idx: number) => (idx + 1) },
                    { title: 'Nomor Tujuan', dataIndex: 'phonenumber', key: 'phonenumber' },
                    { title: 'Pesan', dataIndex: 'message', key: 'message', render: (t: any) => t || '-' },
                    { title: 'Tanggal', dataIndex: 'CreatedAt', key: 'CreatedAt' },
                    { title: 'Status', dataIndex: 'status_label', key: 'status_label', render: (s: any) => <span className='badge bg-secondary'>{s || '-'}</span> },
                  ]}
                />
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </section>
  )
}

export {DashboardAdminWA}
